import { render, staticRenderFns } from "./AgenciaObjetivoImportPage.vue?vue&type=template&id=b513ed9a"
import script from "./AgenciaObjetivoImportPage.vue?vue&type=script&lang=js"
export * from "./AgenciaObjetivoImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports